import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import {LorenFeature} from '../../enums/loren-feature.enum';
import {take} from 'rxjs/operators';
import {LorenFeatureToggleService} from '../../services/loren-feature-toggle-service/loren-feature-toggle.service';

@Directive({
    selector: '[lorenFeatureToggle]',
    standalone: false
})
export class LorenFeatureToggleDirective {
    private templateRef = inject<TemplateRef<unknown>>(TemplateRef);
    private service = inject(LorenFeatureToggleService);
    private viewContainer = inject(ViewContainerRef);


    @Input() set lorenFeatureToggle(enabledFeature: LorenFeature) {
        if (!enabledFeature) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            return;
        }

        this.viewContainer.clear();
        this.service.userHasFeature(enabledFeature).pipe(take(1)).subscribe(x => {
            if (x) {
                this.viewContainer.createEmbeddedView(this.templateRef);
            }
        });
    }
}
